<template>
  <div id="role-and-permission">
    <el-alert
      v-if="userName"
      type="warning"
      style="min-height: 30px; margin: 0 0 5px 0"
      >你正在编辑【{{ userName }}】账号的权限！</el-alert
    >
    <div class="role-and-permission">
      <el-card shadow="hover" style="min-width: 160px">
        <div slot="header" style="display: flex; align-items: center">
          <section>
            <i class="canalManage-icon"></i>
            <span>{{ $STR("dialog_rule_perm_title", "选择角色") }}</span>
          </section>
        </div>
        <section
          style="padding: 20px"
          v-if="
            selectPermissionList.roleDtos &&
            selectPermissionList.roleDtos.length > 0
          "
        >
          <el-checkbox-group
            :disabled="isMyself"
            v-model="roleSelectList"
            class="el-checkbox-group-role"
          >
            <el-checkbox
              :label="item"
              name="type"
              v-for="item in selectPermissionList.roleDtos"
              :key="item.id"
              @change="selectRoleOper(item)"
              style="padding: 10px 0px;"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </section>
        <span v-else style="font-size: large; margin: 10px; color: #2c2c2c">{{
          $STR("ORG.roleAndPermission.noRole", "暂无可授权角色!")
        }}</span>
      </el-card>
      <el-tabs @tab-click="handleClick" v-if="userAuthData === 1">
        <el-tab-pane label="功能权限">
          <div class="role-and-permission">
            <el-card shadow="never" style="flex-grow: 1">
              <div slot="header" style="display: flex; align-items: center">
                <section>
                  <span>云平台权限</span>
                </section>
              </div>
              <el-tree
                class="role-permission-tree"
                :data="allPermissionList"
                ref="allPermissionTree"
                :show-checkbox="!isMyself"
                node-key="id"
                :props="defaultProps"
                :default-expand-all="true"
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span
                    :class="{
                      lastLevel:
                        data.children.length == 0 && data.remarks == '0',
                    }"
                    >{{ node.label }}</span
                  >
                </span>
              </el-tree>
            </el-card>
            <el-card shadow="never" style="flex-grow: 1">
              <div slot="header" style="display: flex; align-items: center">
                <section>
                  <span>量子溯源权限</span>
                </section>
              </div>
              <el-tree
                class="role-permission-tree"
                :data="webAppList"
                ref="webAppListTree"
                :show-checkbox="!isMyself"
                node-key="id"
                :props="defaultProps"
                :default-expand-all="true"
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="数据权限">
          <el-tree
            class="role-permission-tree"
            :data="authorityIds"
            ref="authorityIdsTree"
            :show-checkbox="!isMyself"
            node-key="id"
            :props="defaultProps"
            :default-expand-all="true"
            :expand-on-click-node="false"
            v-show="authorityIds.length > 0"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span
                :class="{
                  lastLevel: data.children.length == 0 && data.remarks == '0',
                }"
                >{{ node.label }}</span
              >
            </span>
          </el-tree>
          <div v-if="hasPermission('menu:jindafu:dataPower') && this.powerBol">
            <template v-for="(item, index) in powerList">
              <template  v-if="item.scopeType === 'SCOPE_DEALER_ORG'">
                <div
                  class="power"
                  :key="item.code + index"
                  ><el-checkbox v-model="powerFlag" style="padding: 10px 0">{{
                    item.name
                  }}</el-checkbox>
                  <i :class="[{ 'el-icon-arrow-down' : !powerFlag}, {'el-icon-arrow-up' : powerFlag}]" style="float: right; margin:15px 10px 0 0;"></i>
                  </div
                >
                <div v-show="powerFlag" class="org_box" :key="item.code + '001'">
                <div class="org-fitler">
                  <div>
                    <el-cascader
                      v-model="region"
                      :options="areaList"
                      :props="cityprops"
                      clearable>
                    </el-cascader>
                    <el-input
                        placeholder="检索经销商/编号"
                        clearable
                        v-model="orgName"
                    >
                    </el-input>
                  </div>
                  <el-checkbox @change="relation">父子关联</el-checkbox>
                </div>
                <el-tree
                  class="role-permission-tree"
                  :data="treeList"
                  ref="powerTree"
                  :show-checkbox="!isMyself"
                  node-key="id"
                  :props="treeProps"
                  :filter-node-method="filterNode"
                  :expand-on-click-node="false"
                  :check-strictly="relationBol"
                  v-loading="loading"
                  @check="check"
                >
                 <span class="custom-tree-node" slot-scope="{ node, data }">
                   <span>{{node.label}}</span>
                   <span>{{data.code}}</span>
                 </span>
                </el-tree>
              </div>
              </template>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-card shadow="never" style="flex-grow: 1" v-if="userAuthData !== 1">
        <div slot="header" style="display: flex; align-items: center">
          <section>
            <span>云平台权限</span>
          </section>
        </div>
        <el-tree
          class="role-permission-tree"
          :data="allPermissionList"
          ref="allPermissionTree"
          :show-checkbox="!isMyself"
          node-key="id"
          :props="defaultProps"
          :default-expand-all="true"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span
              :class="{
                lastLevel: data.children.length == 0 && data.remarks == '0',
              }"
              >{{ node.label }}</span
            >
          </span>
        </el-tree>
      </el-card>
      <el-card shadow="never" style="flex-grow: 1" v-if="userAuthData !== 1">
        <div slot="header" style="display: flex; align-items: center">
          <section>
            <span>量子溯源权限</span>
          </section>
        </div>
        <el-tree
          class="role-permission-tree"
          :data="webAppList"
          ref="webAppListTree"
          :show-checkbox="!isMyself"
          node-key="id"
          :props="defaultProps"
          :default-expand-all="true"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-card>
    </div>
    <div style="text-align: center; padding-top: 15px" v-if="!isMyself">
      <el-button type="primary" plain @click="saveRolePermission" v-duplication
        >{{ $STR("dialog_rule_perm_confirm", "保 存") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import I18NUtil from './../../common/utils/i18nConvert.js';
import { mapActions } from 'vuex';
export default {
    props: [
        'selectRole',
        'userId',
        'tenantId',
        'isHasSelect',
        'userName',
        'userAuthData',
        'powerBol'
    ],
    data() {
        return {
            allPermissionList: [],
            webAppList: [],
            authorityIds: [],
            selectType: [
                {
                    value: '0',
                    label: this.$STR('COMMON.ruleAndPermission.data.type0', '云平台')
                },
                {
                    value: '1',
                    label: this.$STR('COMMON.ruleAndPermission.data.type1', '量子溯源')
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            roleSelectList: [],
            roleList: [],
            selectPermissionList: [],
            array: [],
            type: '0',
            isMyself: false,
            typeIndex: 0,
            checked: false,
            showOrgPowerBol: false,
            treeList: [],
            treeProps: {
                label: 'name',
                children: 'children'
            },
            orgName: '',
            relationBol: true,
            powerList: [],
            saveBatchParams: {},
            powerFlag: false,
            loading: false,
            checkedTree: [],
            areaList: [],
            region: [],
            cityprops: {
                label: 'name',
                value: 'name'
            },
            messages: {
                menu_null: this.$STR('COMMON.ruleAndPermission.method.saveRolePermission.menunull', '菜单列表不能为空'),
            },
        };
    },
    computed: {
        city() {
            return this.region && this.region.length ? this.region[1] : "";
        },
    },
    activated() {
        this.getBaseData();
    },
    mounted() {
        this.isMyself = baseStore.getUserInfo().userId === this.userId;
        this.getRolePermission();
        this.getBaseData();
        this.getPaltFormTypeList();
        this.getAreaTree();
        if (this.hasPermission('menu:jindafu:dataPower') && this.powerBol) {
            this.saveBatchParams = {};
            this.getListAllData();
            this.listByUserId();
        }
    },
    watch: {
        city () {
            this.$refs.powerTree[0].filter(this.orgName);
        },
        orgName(val) {
            this.$refs.powerTree[0].filter(val);
        },
        userId() {
            this.orgName = "";
            this.isMyself = baseStore.getUserInfo().userId === this.userId;
            this.getRolePermission();
            this.treeList = [];
            if (this.hasPermission('menu:jindafu:dataPower') && this.powerBol) {
                this.saveBatchParams = {};
                this.getListAllData();
                this.listByUserId();
                this.$refs.powerTree[0].setCheckedKeys([]);
                this.powerFlag = false;
            }
        }
    },
    methods: {
        ...mapActions(["getAreaTreeAction"]),
        filterNode(value, { code, name, city }) {
            if (this.city && this.city !== city) return false;
            if (!value) return true;
            return (code && code.indexOf(value) > -1) || (name && name.indexOf(value) > -1);
        },
        async getAreaTree() {
            const area = await this.getAreaTreeAction(this.$http);
            // 裁剪，仅显示省市
            area.forEach(item => {
                item.children.forEach(child => { delete child.children; });
            });
            this.areaList = area;
        },
        //获取权限列表
        getPaltFormTypeList() {
            var temp = function (val, target) {
                var list = val;
                target.selectType = list;
            };
            commonRequest.getDataDictionary('paltform_type', this, temp);
        },
        getBaseData() {
            var me = this;
            let getAllPermission = me.getAllPermission();
            let getWebAppList = me.getWebAppList();
            let getUserAuthorityIds = me.getUserAuthorityIds();
            // let getAllWrapper = backend.request(api.Pack.selectAllWrapper, {})
            return Promise.all([
                getAllPermission,
                getWebAppList,
                getUserAuthorityIds
            ]).then(
                (result) => {
                    if (result) {
                        me.getRolePermission();
                    } else {
                        return Promise.reject(result);
                    }
                },
                () => {}
            );
        },
        getUserAuthorityIds() {
            this.$http.get(WebApi.roleManage.userAuthority).then((response) => {
                this.authorityIds = response.data.data.children;
            });
        },
        async getWebAppList() {
            const { data } = await this.$http.get(WebApi.roleManage.appGroup);
            this.webAppList = data.data;
            this.webAppList.forEach(app => {
                app.name = app.groupName;
                app.packages.forEach((pkg) => pkg.name = pkg.appName);
                app.children = app.packages;
            });
        },
        filterKeys(arr) {
            var me = this;
            arr.forEach((item) => {
                if (item.children && item.children.length > 0) {
                    me.filterKeys(item.children);
                } else {
                    me.array.push(item.id);
                }
            });
            return me.array;
        },
        setTreestatus(arr, ids) {
            var me = this;
            arr.forEach((item) => {
                item.disabled = ids.indexOf(item.id) > -1;
                if (item.children && item.children.length > 0) {
                    me.setTreestatus(item.children, ids);
                }
            });
            return arr;
        },
        selectRoleOper(item) {
            // console.log(item);
            let menuIds = [];
            let appMenu = [];
            let authority = [];
            for (let item of this.roleSelectList) {
                menuIds = menuIds.concat(item.menuIds);
                appMenu = appMenu.concat(item.packageIds);
                if (this.userAuthData === 1) {
                    authority = authority.concat(item.authorityIds);
                }
            }
            menuIds = this.uniq(menuIds);
            appMenu = this.uniq(appMenu);
            authority = this.uniq(authority);
            this.allPermissionList = this.setTreestatus(
                this.allPermissionList,
                menuIds
            );
            this.setCheckedKeysMenu(menuIds);
            this.webAppList = this.setTreestatus(this.webAppList, appMenu);
            this.setCheckedKeysAPP(appMenu);
            if (this.userAuthData === 1) {
                this.authorityIds = this.setTreestatus(this.authorityIds, authority);
                this.setCheckedKeysData(authority);
            }
            /*this.$refs.allPermissionTree.setCheckedKeys(menuIds);*/
        },
        setCheckedKeysMenu(data) {
            let _self = this;
            var filterIds = _self.filterKeys(_self.allPermissionList);
            for (let i = 0; i < data.length; i++) {
                if (filterIds.indexOf(data[i]) === -1) {
                    data.splice(i, 1);
                    i--;
                }
            }
            _self.$refs.allPermissionTree.setCheckedKeys(data);
        },
        setCheckedKeysAPP(data) {
            let _self = this;
            var filterIds = _self.filterKeys(_self.webAppList);
            for (let i = 0; i < data.length; i++) {
                if (filterIds.indexOf(data[i]) === -1) {
                    data.splice(i, 1);
                    i--;
                }
            }
            _self.$refs.webAppListTree.setCheckedKeys(data);
        },
        setCheckedKeysData(data) {
            let _self = this;
            var filterIds = _self.filterKeys(_self.authorityIds);
            for (let i = 0; i < data.length; i++) {
                if (filterIds.indexOf(data[i]) === -1) {
                    data.splice(i, 1);
                    i--;
                }
            }
            _self.$refs.authorityIdsTree.setCheckedKeys(data);
        },
        uniq(array) {
            return [...(new Set(array))];
        },
        getSaveRolePermissionParams() {
            const { allPermissionTree, webAppListTree, authorityIdsTree } = this.$refs;
            const roleIds = this.roleSelectList.map((item) => item.id);
            const menuIds = allPermissionTree
                .getCheckedKeys()
                .concat(allPermissionTree.getHalfCheckedKeys());
            const packageIds = webAppListTree
                .getCheckedKeys()
                .concat(webAppListTree.getHalfCheckedKeys());

            let authorityIds = [];
            if (this.userAuthData === 1) {
                authorityIds = authorityIdsTree
                    .getCheckedKeys()
                    .concat(authorityIdsTree.getHalfCheckedKeys());
            }

            return {
                menuIds,
                packageIds,
                authorityIds,
                roleIds,
                userId: this.userId,
                tenantId: this.tenantId,
            };
        },
        async saveRolePermission() {
            // authorityIdsTree：数据权限
            // webAppListTree：量子溯源权限
            // allPermissionTree：云平台权限
            const { allPermissionTree, webAppListTree, authorityIdsTree } = this.$refs;

            // 目前外部调用isHasSelect传值都是1, 这值干嘛用的?
            if (this.isHasSelect === 1) {
                const hasCheckedKeys =
                    allPermissionTree.getCheckedKeys().length > 0 ||
                    webAppListTree.getCheckedKeys().length > 0 ||
                    (this.userAuthData === 1 && authorityIdsTree.getCheckedKeys().length > 0);
                if (!hasCheckedKeys) {
                    this.$message({
                        showClose: true,
                        message: this.messages.menu_null,
                        type: 'error'
                    });
                    return;
                }
                let params = this.getSaveRolePermissionParams();
                const res = await this.$http.post(WebApi.roleManage.insertTenant, params);
                if (res.data.success) {
                    this.$emit('ok');
                    $ActionAlert(res, this);
                } else {
                    this.$message({
                        showClose: true,
                        message: this.$STR(res.data.resultCode, res.data.message),
                        type: 'error'
                    });
                }
            } else {
                const roleIds = this.roleSelectList.map(item => item.id);
                const menuIds = allPermissionTree
                    .getCheckedKeys()
                    .concat(allPermissionTree.getHalfCheckedKeys());
                const postParams = {
                    menuIds,
                    roleIds,
                    userId: this.userId,
                };
                const res = await this.$http.post(WebApi.roleManage.userPrivelege, postParams);
                if (res.data.success) {
                    this.$emit('ok');
                    $ActionAlert(res, this);
                } else {
                    this.$message({
                        showClose: true,
                        message: this.$STR(res.data.resultCode, res.data.message),
                        type: 'error'
                    });
                }
            }
            if (this.hasPermission('menu:jindafu:dataPower') && this.powerBol) {
                this.getSaveBatch();
            }
        },
        nodeExpand() {
            let lastLevelList = document.getElementsByClassName('lastLevel');
            this.$nextTick(() => {
                if (lastLevelList.length > 0) {
                    for (var i = 0; i < lastLevelList.length; i++) {
                        var group = this.nodeExpandFind(
                            document.getElementsByClassName('lastLevel')[i],
                            'group'
                        );
                        group.style.display = 'flex';
                        group.style.justifyContent = 'flex-start';
                        group.style.width = '70%';
                        var treeItem = this.nodeExpandFind(group, 'treeitem');
                        treeItem.style.display = 'flex';
                        treeItem.style.justifyContent = 'space-between';
                        treeItem.children[0].children[0].style.display = 'none';
                        treeItem.children[0].children[1].style.padding = '0 0 0 24px';
                        treeItem.children[0].style.width = '30%';
                        treeItem.children[0].onclick = () => {
                            event.stopPropagation();
                        };
                        treeItem.onmouseover = function () {
                            this.style.backgroundColor = 'rgb(208, 237, 254)';
                        };
                        treeItem.onmouseout = function () {
                            this.style.backgroundColor = '#ffffff';
                        };
                    }
                }
            });
        },
        nodeExpandFind(ele, flag) {
            if (ele.parentElement.getAttribute('role') !== flag) {
                return this.nodeExpandFind(ele.parentElement, flag);
            } else {
                return ele.parentElement;
            }
        },
        getAllPermission() {
            let _self = this;
            _self.$http.get(WebApi.homeMenu.menuData).then((response) => {
                _self.allPermissionList = [];
                if (response.data.success) {
                    I18NUtil.convertMenuList(response.data.data, _self);
                    _self.allPermissionList = response.data.data.children;
                    _self.nodeExpand();
                }
            });
        },
        getRolePermission() {
            let _self = this;
            _self.$http
                .get(WebApi.roleManage.getByUserId + '/' + this.userId)
                .then((response) => {
                    if (response.data.success) {
                        _self.selectPermissionList = response.data.data;
                        _self.roleSelectList = [];
                        let arr = [];
                        let appArr = [];
                        let authorityArr = [];
                        for (let item of _self.selectPermissionList.roleDtos) {
                            if (item.check) {
                                _self.roleSelectList.push(item);
                                arr = arr.concat(item.menuIds);
                                appArr = appArr.concat(item.packageIds);
                                if (this.userAuthData === 1) {
                                    authorityArr = authorityArr.concat(item.authorityIds);
                                }
                            }
                        }
                        let menu = arr.slice(0);
                        _self.allPermissionList = _self.setTreestatus(
                            _self.allPermissionList,
                            menu
                        );

                        let app = appArr.slice(0);
                        _self.webAppList = _self.setTreestatus(_self.webAppList, app);
                        arr = arr.concat(_self.selectPermissionList.userMenuIds);
                        appArr = appArr.concat(_self.selectPermissionList.userPackageIds);

                        _self.setCheckedKeysMenu(arr);
                        _self.setCheckedKeysAPP(appArr);
                        if (this.userAuthData === 1) {
                            let authority = authorityArr.slice(0);
                            _self.authorityIds = _self.setTreestatus(
                                _self.authorityIds,
                                authority
                            );
                            authorityArr = authorityArr.concat(
                                _self.selectPermissionList.userAuthorityIds
                            );
                            _self.setCheckedKeysData(authorityArr);
                        }
                        /*for (let item of _self.roleList) {
                            _self.permissionList = _self.permissionList.concat(item.menuIds);
                        }*/
                    }
                });
        },
        handleClick(tab, event) {
            this.typeIndex = tab.index;
        },
        // 查询组织结构树接口
        getAllOrgTree() {
            // console.log(123456);
            let params = {
                orgName: this.orgName || '', //组织名称 组织编号
                orgState: 1
            };
            this.$http
                .get(WebApi.organization.orgTree, { params })
                .then((res) => {
                    // console.log('res: ', res);
                    this.treeList = res.data.record.length ? res.data.record[0].children : [];
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        searchOrg() {
            this.getAllOrgTree();
        },
        relation(val) {
            this.relationBol = !val;
        },
        // 获取数据权限
        getListAllData() {
            this.$http.get(WebApi.dataPower.listAllData).then((res) => {
                if (res.data.success) {
                    this.powerList = res.data.data;
                }
            });
        },
        // 根据用户ID获取到用户拥有的权限
        listByUserId() {
            this.loading = true;
            this.$http.get(WebApi.dataPower.listByUserId + '?userId=' + this.userId).then((res) => {
                if (res.data.success) {
                    if (res.data.data.length > 0) {
                        res.data.data.map(i => {
                            this.saveBatchParams[i.scopeType] = i;
                        });
                    }
                }
                // console.log((this.saveBatchParams.SCOPE_DEALER_ORG && this.saveBatchParams.SCOPE_DEALER_ORG.scopes.length > 0));
                (this.saveBatchParams.SCOPE_DEALER_ORG && this.saveBatchParams.SCOPE_DEALER_ORG.scopes.length > 0) ? this.powerFlag = true : this.powerFlag = false;
                this.getAllOrgTree();
                this.$refs.powerTree[0].setCheckedKeys(this.saveBatchParams.SCOPE_DEALER_ORG ? this.saveBatchParams.SCOPE_DEALER_ORG.scopes : []);
            });
        },
        getSaveBatch() {
            // this.saveBatchParams.scopes = this.$refs.powerTree[0].getCheckedKeys();
            // console.log('this.saveBatchParams', this.saveBatchParams);
            this.check();
            this.powerList.forEach(i => {
                (i.code === 'DP_CODE_OWN_DEALER') && (this.saveBatchParams['SCOPE_DEALER_ORG'] = {userId: this.userId, scopes: this.checkedTree, code: i.code});
            });
            let params = [];
            params.push(...Object.values(this.saveBatchParams));
            console.log(params, this.saveBatchParams);
            this.$http.put(WebApi.dataPower.saveBatch, params).then((res) => {
            });
        },
        check() {
            this.checkedTree = [];
            this.$refs.powerTree[0].getCheckedKeys().map(i => {
                if (this.$refs.powerTree[0].getHalfCheckedKeys().indexOf(i) === -1 ) {
                    this.checkedTree.push(i);
                }
            });
        }
    }
};
</script>
<style lang="scss">
#role-and-permission {
  .org-fitler {
    align-items: center;
    .el-input {
      width: 160px !important;
    }
  }
}
</style>
<style scoped>
.role-and-permission {
  display: flex;
  flex: 1;
  overflow-y: auto;
}
#role-and-permission {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
#role-and-permission .el-card {
  height: auto;
}
#role-and-permission .role-permission-tree .el-tree-node__content {
  height: 24px !important;
}
#role-and-permission .el-checkbox-group {
  display: flex;
  flex-direction: column;
}
#role-and-permission .el-checkbox {
  line-height: inital !important;
  /* padding: 10px 0px; */
}
</style>
<style lang="scss" scoped>
.power {
  margin-top: 0 !important;
  padding: 5px;
  &:hover {
    background-color: #d5efff;
    /deep/ .el-checkbox__label {
      color: #409eff !important;
    }
  }
  /deep/ .el-checkbox__label {
    color: #000 !important;
  }
}
.power,
.org_box {
  margin-top: 10px;
  color: #333;
  padding-left: 23px;
}
.org_box {
  & > div:first-of-type {
    display: flex;
    justify-content: space-between;
    span {
      line-height: 31px;
    }
    span:last-of-type {
      .el-input {
        width: 200px;
        margin: 0 5px 0 10px;
      }
    }
    label{
      margin-left: 10px;
    }
  }
  .el-tree {
    margin-top: 5px;
    padding: 10px 15px;
    border: 1px solid #e4e7ed;
  }
}
  .el-tabs {
    flex: 1;
    padding-right: 20px;
  }
  /deep/ .el-tree-node__content{
    line-height: 35px !important;
    height: 35px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/roleAndPermission.vue